import Vue from 'vue';
import * as Sentry from '@sentry/vue';

export default function (router) {
  if (
    process.env.NODE_ENV !== 'development' &&
    !!FRONT_SENTRY_DNS &&
    !!DOCKER_IMAGE_TAG &&
    !!SENTRY_ENVIROMENT
  ) {
    Sentry.init({
      Vue,
      dsn: FRONT_SENTRY_DNS,
      release: DOCKER_IMAGE_TAG,
      environment: SENTRY_ENVIROMENT,
      integrations: [Sentry.browserTracingIntegration({ router })],
    });
  }
}
